import ApiService from './ApiService';
import PushService from './PushService';

class AuthService {

  // `login` is the account's email or username.
  async login(login, password, otp = null) {
    try {
      const response = await ApiService.request({
        method: 'POST',
        url: '/admin/login',
        data: { login, password, ...(otp && { otp }) },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      throw error;
    }
  }

  async logout() {
    // Unregister this device first — the call still needs the session token.
    await PushService.unregister();
    localStorage.removeItem('admin');
    localStorage.removeItem('permissions');
    window.location.href = process.env.REACT_APP_BASE_PATH + '/admin/login';
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('admin'));
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
